export default __webpack_public_path__ + "static/media/next_icon.bf60e57f.svg";